  export function removeElementFromArray(arr, element) {
    return arr.filter(item => item !== element);
  }
  
  
  export function isObjectEmpty(obj) {
    return Object?.keys(obj).length === 0 && obj?.constructor === Object;
  }

  export function sortEmployeeRanges (items)  {
    // Helper function to extract the numeric values from the name
    const extractMinValue = (name) => {
      
      const [min] = name.split(" - ").map(Number);
      return min;
    };
  
    // Sorting the items based on extracted minimum values
    return items.sort((a, b) => extractMinValue(a.name) - extractMinValue(b.name));
  };
